module.exports = __webpack_public_path__ + "static/media/globe.3099e27b.svg";